module.exports = __webpack_public_path__ + "static/img/lhz.fa57d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/lhz.jpg
// module id = 4HOt
// module chunks = 0